import axios from 'axios';

const setCSRFToken = (token) => {
        axios.defaults.headers.common['X-CSRF-Token'] = token
};

export default setCSRFToken;
